import { isValidCPF } from '@brazilian-utils/brazilian-utils';
import { t } from 'i18next';
import { isFilled } from 'utils/old-ui-commons/validations';

export const formValidate = (values) => {
  const errors = {};

  if (!isValidCPF(values.cpf)) {
    errors.cnpj = [t`invalid CPF`];
  }

  if (!isFilled(values.name)) {
    errors.name = [t`please fill in this field`];
  }

  return errors;
};

export const CPF_MASK = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

export const PHONE_PATTERN = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
